<template>
   
  <transition name="modal">
    <div class="modal-mask">
      <div class="modal-wrapper">
        <div class="modal-container">

          <div class="modal-header" style="position: relative;">
            <slot name="header">
              <h4>{{kombox.content}} - {{name()}}</h4>
              
           
             <button type="link" v-focus
                style="position: absolute; top:15px; right:15px; border: 0 none;"
                class="btn btn-default btn-lg" 
                @click="$emit('close')"
                @keyup.esc="$emit('close')"
                title="Fenster schließen">
                <span class="glyphicon glyphicon-remove" aria-hidden="true"></span>
            </button>

            </slot>
          </div>

          <div class="modal-body">
            <slot name="body">
              <div v-show="acdText == 'Off'" class="alert alert-warning" role="alert">Keine ACD Eingrichtet</div>

              <div v-show="!acdKey" class="alert alert-warning" role="alert">Nicht an der ACD angemeldet</div>
              
              <div v-show="acdKey && acdText != 'Off'" class="alert alert-warning" role="alert">ACD integration (noch) nicht implementiert ! ACD: {{acdText}} ACD-Login: {{acdKey}}</div>
              

            <form v-focus @keyup.esc="$emit('close')" @submit.prevent="submit" :id="_uid" >
              
                <div class="" v-for="(textTemplate, i) in textTemplates">
                  <label class="" style="margin-top:20px; ">{{textTemplate.headline}}</label>
                  <ul class="">
                  <li v-for="(content, j) in textTemplate.contents"
                    @dblclick="onClickAddTemplate(i,j)"
                  >
                    {{content}}
                    <button type="button"
                      @click="onClickAddTemplate(i,j)"
                      class="btn btn-default pull-right"
                      style="border:0 none; padding:0px; color: #aaa" >
                        <i class="fa fa-file-text" aria-hidden="true"></i>
                        <i class="fa fa-arrow-right" aria-hidden="true"></i>
                      </button>
                  </li>
                  </ul>
                </div>
              
                
              </form>
            </slot>
          </div>

          <div class="modal-footer">
            <slot name="footer">

              <button type="" 
                class="btn btn-default"
                @click="$emit('close')">
                close
              </button>
              
            </slot>
          </div>
        </div>
      </div>
    </div>
  </transition>

</template>



<script>

import bus from './common/bus'
import * as miscConf from './common/misc.conf'


export default {
  
  
  components: {
  },  
  
  props: {
    content: '',
    kombox: '',
  },
  
  data () {
    return {
      textTemplates:[
        {
          headline: 'erreicht...',
          contents: [
            'Anruf verbunden',
            'Anruf wurde abgelehnt (zurückgenommen)',
            'Anrufdaten telefonisch übergeben',
          ]
        },
        {
          headline: 'nicht erreicht...',
          contents: [
            'Freizeichen',
            'Anschluß besetzt (Besetztzeichen)',
            'Anschluß derzeit nicht erreichbar (Handyansage)',
          ]
        },
        {
          headline: 'Anrufbeantworter...',
          contents: [
            'Anrufbeantworter - kein Text hinterlassen',
            'Anrufbeantworter - Text hinterlassen',
            'Anrufbeantworter - Anrufer verbunden',
        
          ]
        },
        {
          headline: 'falscher Ansprechpartner...',
          contents: [
            'Falscher Ansprechpartner - Nachricht hinterlassen',
            'Falscher Ansprechpartner - keine Nachricht hinterlassen',
          ]
        },
      ],
      
      src: '',
      acdKey: bus.login.acdKey,
    }
  },
  
  mounted: function () {
  },
  
  created: function () {
    
    
    // default
    this.src = this.content;
    return;
    
  },
  
  computed: {
    
    acdText: function() {
      return miscConf.acdText(bus.login.companyCallCenter.acdTyp);
    },
    

    
  },  
  
  
  methods: {
    
    name: function () {
      
      let name;
      
      if(this.kombox.idUser > '0'){
        if(bus.cache.userClient.lastName){
          name = bus.cache.userClient.firstName + " " + bus.cache.userClient.lastName;
        }else if(bus.cache.userClient.function){
          name = bus.cache.userClient.function;
        }else if(bus.cache.userClient.department){
          name = bus.cache.userClient.department;
        }else if(bus.cache.userClient.room){
          name = bus.cache.userClient.room;
        }else{
          name = "Mitarbeiter";
        }
      }else{
        name = bus.cache.companyClient.messageTextShort;
      }
      return name;
      
    },

    onClickAddTemplate: function (i,j) {
      
      const msg = this.name() + ', ' + this.content + ', ' + this.textTemplates[i].contents[j] + "\n";
      bus.emitAddMessage(msg);
      this.$emit('close');
    },

    
  },
}
  
</script>



<style scoped>
  
  ul{
    list-style-type: none;
    margin: 0;
    padding: 0;
    vertical-align:middle;
  }
  
  li:first-child{
      border-top: 1px solid lightgrey;
    
  }
  
  li{
    border-bottom: 1px solid lightgrey;
    height:30px;
    padding-top: 5px;
    padding-bottom: 5px;
    vertical-align:middle;
  }
  
  li:hover{
    background-color: #eee;  
  }
  
  
  

 .modal-mask {
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, .5);
  display: table;
  transition: opacity .3s ease;
}

.modal-wrapper {
  display: table-cell;
  vertical-align: middle;
}

.modal-container {
  width: 60vh;
  /*margin: 0px auto;*/
  margin-left: 15%;
  padding: 20px 30px;
  background-color: #fff;
  border-radius: 2px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, .33);
  transition: all .3s ease;
  font-family: Helvetica, Arial, sans-serif;
}

.modal-header h3 {
  margin-top: 0;
}

.modal-body {
  overflow: scroll;
  height:60vh;
  margin: 20px 0;
}

.modal-footer {
  margin-top: 30px;
  padding-top: 30px;
  border-top: 1px solid lightgray;
  text-align: right;
}


  
  
  
  
  
/*
 * The following styles are auto-applied to elements with
 * transition="modal" when their visibility is toggled
 * by Vue.js.
 *
 * You can easily play with the modal transition by editing
 * these styles.
 */

.modal-enter {
  opacity: 0;
}

.modal-leave-active {
  opacity: 0;
}

.modal-enter .modal-container,
.modal-leave-active .modal-container {
  -webkit-transform: scale(1.1);
  transform: scale(1.1);
}

input:invalid {
  border: 1px solid red;
}  

</style>



// WEBPACK FOOTER //
// PhoneTool.vue?46da5f24